import api from '@/api'
import { firebaseApp, firebaseFunctions } from '@/firebase'

const store = {
  state: {
    dataMenuItem: [],
    pagingMenuItem: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingMenuItem: {
      byField: '',
      isDesc: false
    },
    filteringMenuItem: {
      outletCode: null,
      menuItemCode: null,
      menuGroupCode: null,
      menu_group_name: null,
      sequence: null,
      isTaxable: null,
      isActive: null,
      isMenuset: null,
      isCD: null,
      outOfStock: null,
      name: null
    }
  },

  mutations: {
    SET_MENUITEM: (state, payload) => {
      state.dataMenuItem = payload
    },
    SET_PAGING_PAGE_MENUITEM: (state, payload) => {
      state.pagingMenuItem.page = payload
    },
    SET_PAGING_TOTAL_MENUITEM: (state, payload) => {
      state.pagingMenuItem.total = payload
    },
    SET_SORTING_MENUITEM: (state, payload) => {
      state.sortingMenuItem = payload
    },
    SET_FILTERING_MENUITEM: (state, payload) => {
      state.filteringMenuItem = payload
    }
  },

  getters: {
    SortingMenuItem: state => state.sortingMenuItem,
    FilteringMenuItem: state => state.filteringMenuItem,
    PagingMenuItem: state => state.pagingMenuItem,
    GetAllMenuItem: state => state.dataMenuItem,
    GetOneMenuItem: state => id =>
      state.dataMenuItem.find(dataMenuItem => dataMenuItem.id === id)
  },

  actions: {
    async UpdateSortingMenuItem({ commit, dispatch }, payload) {
      commit('SET_SORTING_MENUITEM', {
        byField: payload.byField,
        isDesc: payload.isDesc
      })
      dispatch('GetAllMenuItem')
    },

    async UpdateFilteringMenuItem({ commit, dispatch, state }, isResetField) {
      if (isResetField) {
        const emptyFilter = {
          cond: null,
          code: null,
          description: null,
          sequence: null,
          outletCode: localStorage.getItem('outletCodes')
        }
        commit('SET_FILTERING_MENUITEM', emptyFilter)
      }
      commit('SET_PAGING_PAGE_MENUITEM', 1)
      dispatch('GetAllMenuItem')
    },

    async GetAllMenuItem({ commit, state }) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const { data } = await firebaseFunctions.httpsCallable(
          'refreshAuthUser'
        )({
          loginId: firebaseApp.auth().currentUser!.uid
        })
        if (data.data.Type !== 'Admin') {
          const splitOutletCodes = data.data.OutletCodes
          if (
            !state.filteringMenuItem.outletCode ||
            !splitOutletCodes.includes(state.filteringMenuItem.outletCode)
          ) {
            commit('SET_FILTERING_MENUITEM', {
              ...state.filteringMenuItem,
              outletCode: splitOutletCodes.join(',')
            })
          }
        }
        if (
          data.data.Type !== 'Admin' &&
          (!data.data.OutletCodes || !data.data.OutletCodes.length)
        ) {
          commit('SET_IS_FETCHING_DATA', false)
          commit('SET_MENUITEM', [])
          return []
        }
        const result = await api.GetAllMenuItem(
          state.pagingMenuItem,
          state.sortingMenuItem,
          state.filteringMenuItem
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit('SET_PAGING_TOTAL_MENUITEM', result.headers['data-length'])
        commit('SET_MENUITEM', result.data.data)
        return result.data
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async CreateMenuItem({ dispatch }, payload) {
      try {
        const { data } = await api.CreateMenuItem(payload)
        dispatch('GetAllMenuItem')
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateMenuItem({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateMenuItem(payload.id, payload)
        dispatch('GetAllMenuItem')
        return data
      } catch (e) {
        return e.response
      }
    },

    async DeleteMenuItem({ dispatch }, id) {
      try {
        const { data } = await api.DeleteMenuItem(id)
        dispatch('GetAllMenuItem')
        return data
      } catch (e) {
        throw e
      }
    },

    async changeStockStatus({ dispatch, commit }, payload) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const { data } = await api.changeStockStatus(payload.id, {
          OutOfStock: payload.OutOfStock
        })
        dispatch('GetAllMenuItem')
        return data
      } catch (e) {
        return e.response
      }
    }
  }
}

export default store
